import LazyLoad from "vanilla-lazyload";
import "@taocode/audio-player";
import { initWorksFilter } from "./works-filter.js";

// import Swiper from 'swiper';
//// core version + navigation, pagination modules:
// import SwiperCore, { Autoplay, EffectFade, Navigation, Pagination, Zoom } from 'swiper/core';
//// configure Swiper to use modules
// SwiperCore.use([Autoplay, EffectFade, Navigation, Pagination, Zoom]);

function initLazyLoad() {
  var lazyLoadInstance = new LazyLoad({});
}

function initMenuToggle() {
  let showMenu = document.getElementById('show-menu')
  let menuToggle = document.getElementById('toggle-menu')
  if (!menuToggle) return
  menuToggle.addEventListener('click', () => {
    showMenu.checked = !showMenu.checked
    menuToggle.setAttribute('aria-expanded', showMenu.checked ? 'true' : 'false')
  })
  window.matchMedia('(min-width: 640px)').addEventListener('change', (e) => {
    if (e.matches) {
      showMenu.checked = false
      menuToggle.setAttribute('aria-expanded', 'false')
    }
  })
}
function updateThemeSwitchers(darkMode) {
  const html = document.documentElement
  if (darkMode) {
    html.setAttribute('data-theme', 'dark')
  } else {
    html.removeAttribute('data-theme')
  }
  Array.from(document.querySelectorAll('taocode-audio-player')).forEach((el) => {
    el.setAttribute( 'mode', darkMode ? 'dark' : 'light' )
    console.log({el},el.dataset,el.getAttribute(el.dataset.themeSwitch),el.mode)
  })
}
function initDarkMode() {
  const lsThemeMode = localStorage.getItem('theme-mode')
  let darkMode = (lsThemeMode !== null) 
            ? lsThemeMode !== 'light' 
            : ! matchMedia('(prefers-color-scheme: light)').matches
  updateThemeSwitchers(darkMode)
  const toggleDarkMode = document.getElementById('toggle-dark-mode')
  if (!toggleDarkMode) return
  toggleDarkMode.addEventListener('click',() => {
    darkMode = !darkMode
    updateThemeSwitchers(darkMode)
    localStorage.setItem('theme-mode', darkMode ? 'dark' : 'light')
  })   
}

// title charm
if (!/^(amberferenz.com|localhost)$/.test(window.location.hostname)) {
  document.title = 'β '+document.title;
} else if (window.location.hostname == 'localhost') {
  // other favorite symbols: Ҩ ҩ Ϟ ֎ ߷ બ ૭ இ ഽ ෴
  document.title = '჻ '+document.title;
}

// for Carousel use and more

window.getPreviousSibling = (elem, selector) => {
  var sibling = elem.previousElementSibling;
  if (!selector) return sibling;
  while (sibling) {
    if (sibling.matches(selector)) return sibling;
    sibling = sibling.previousElementSibling
  }
};
window.getNextSibling = (elem, selector) => {
  var sibling = elem.nextElementSibling;
  if (!selector) return sibling;
  while (sibling) {
    if (sibling.matches(selector)) return sibling;
    sibling = sibling.nextElementSibling
  }
};

function init() {
  initMenuToggle();
  initDarkMode();
  initLazyLoad();
  initWorksFilter();
}

document.addEventListener("DOMContentLoaded", init);